<template>
  <div id="settings" class="wrrapper mb-1">
    <page-heading title="Branch Settings" border />

    <data-table
      :cols="columns"
      :rows="brachData"
      height="calc(100vh - 15rem)"
      :loading="loading"
    >
      <template slot="action" slot-scope="{ actions }">
        <dropdown-menu :rowData="actions" :handleItemClick="handleItems" />
      </template>
    </data-table>

    <modal
      title="Add Branch"
      name="addbranchmodal"
      class="custom-modal"
      height="auto"
      width="600"
      :adaptive="true"
    >
      <template v-slot:content>
        <form @submit.prevent class="create-service branch-modal-form">
          <Input
            class="mb-base"
            label="Name"
            type="text"
            v-model="registrationData.branchName"
          />
          <Input
            class="mb-base"
            label="Bussiness Address"
            v-model="registrationData.branchAddress"
            type="text"
          />
          <Input
            class="mb-base"
            label="Phone Number"
            v-model="registrationData.phoneNumber"
            type="number"
          />
          <Input
            class="mb-base"
            label="Email"
            type="email"
            v-model="registrationData.email"
          />
          <div class="mb-base">
            <Upload
              label="Upload Picture"
              @update-picture="handleFileUpload"
              for="upload-photo"
              class="flex justify-center"
            />
          </div>
          <div class="branch-modal-actions">
            <Button
              className="button--transparent custom-button"
              title="Cancel"
              :onClick="handleCancelModal"
            />
            <Button
              className="button--primary custom-button"
              title="Proceed"
              :loader="loading"
              :onClick="handleCreatebranch"
            />
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import Button from "@/components/Button";
import DataTable from "@/components/DataTable";
import DropdownMenu from "@/components/DropdownMenu";
import Modal from "@/components/Modal";
import Input from "@/components/Input";

import { mapActions, mapGetters } from "vuex";
import Upload from "../../../components/Upload.vue";
export default {
  components: {
    Button,
    DataTable,
    DropdownMenu,
    Input,
    Modal,
    Upload
  },
  data() {
    return {
      id: "",
      columns: [
        { column: "serial", label: "#", width: "60" },
        {
          column: "name",
          label: "Branch Name",
          sortable: true,
          link: true,
          routerName: "BranchSetting"
        },
        {
          column: "created_at",
          label: "Created At",
          sortable: true,
          sort: true
        }
      ],
      brachData: [],
      registrationData: {}
    };
  },
  methods: {
    ...mapActions("bussiness", [
      "addBussinessSettings",
      "updateSettings",
      "settingsList",
      "createBranch"
    ]),
    ...mapActions("expenses", ["fetchBranch"]),
    ...mapActions("auth", ["uploadAttachment"]),
    toggleAddBranchModal() {
      this.$modal.show("addbranchmodal");
    },
    handleCancelModal() {
      this.$modal.hide("addbranchmodal");
    },
    handleFileUpload(file) {
      this.uploadAttachment({ file: file });
    },
    saveData() {
      const template = {
        header: this.$refs.header.editor.getContents(),
        footer: this.$refs.footer.editor.getContents(),
        note: this.$refs.note.editor.getContents()
      };
      if (this.settings.length > 0) {
        this.updateSettings({ id: this.id, payload: template }).then(() => {
          this.$toasted
            .success("Bussiness settings updated successfully")
            .goAway("3000");
        });
      } else {
        this.addBussinessSettings(template).then(() => {
          this.$toasted
            .success("Bussiness settings saved successfully")
            .goAway("3000");
        });
      }
    },
    handleCreatebranch() {
      if (this.registrationData.branchName) {
        const template = {
          tenantId: this.user?.tenantId,
          name: this.registrationData.branchName,
          logoPath: this.attachmentUrl,
          attachmentId: this.attachmentId,
          email: this.registrationData.email,
          phone_number: this.registrationData.phoneNumber,
          header: {},
          footer: {}
        };
        this.createBranch({ payload: template }).then(() => {
          this.$modal.hide("addbranchmodal");
          this.$toasted.success("Branch Created successfully").goAway("3000");
        });
      } else {
        this.$toasted.error("Please check all input feilds").goAway("3000");
      }
    },
    handleItems() {}
  },
  computed: {
    ...mapGetters({
      settings: "bussiness/settings",
      loading: "loading",
      fetchUserBranch: "expenses/fetchUserBranch",
      attachmentId: "auth/attachmentId",
      attachmentUrl: "auth/attachmentUrl",
      user: "auth/userInfo"
    })
  },
  watch: {
    settings(val) {
      const ref = this.$refs || {};
      const item = val.find(item => item);
      if (item) {
        ref.header.editor.setContents(item.header, "api");
        ref.footer.editor.setContents(item.footer, "api");
        ref.note.editor.setContents(item.note, "api");
        this.id = item.id ? item.id : "";
      }
    }
  },
  async mounted() {
    await this.fetchBranch();
    await this.fetchUserBranch?.map(item => {
      this.brachData.push({
        tenantId: this.user?.tenantId,
        id: item?.id,
        createdAt: item?.created_at,
        createdBy: item?.user?.employ?.full_name,
        name: item?.name
      });
    });
  }
};
</script>

<style scoped>
.branch-modal-form {
  padding-top: 4px;
}

.branch-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

.branch-modal-actions ::v-deep .button--transparent span {
  color: var(--text);
}
</style>
